import React, { useState } from 'react'
import './Enquiry.css'


//toast notification library 
import {ToastContainer,toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//axios
import axios from "axios"

//assets
import queryicon from '../../assets/question.png'
import enqueryimage from "../../assets/enquiry_img.png"

const Enquiry = () =>{

  //state for input values
const [name,setName]=useState("");
const [department,setDepartment]=useState("");
const [project_title,setProject_title]=useState("")
const [cost_expectation,setCost_expectation]=useState("")
const [mobile_number,setMobile_number]=useState("");
const [mail_id,setMail_id]=useState("");
const [college_name,setCollege_name]=useState("");
const [place,setPlace]=useState("")
const [batch_memebers,setBatch_members]=useState("");
const [delivery_date,setDelivery_date]=useState("");
const [message,setMessage]=useState("");

const handleSubmit= async(e)=>{
    e.preventDefault();

    //validate if any input field is empty 
    if(!name || !department || !project_title||!cost_expectation||!mobile_number||!mail_id || !college_name ||!place ||!batch_memebers||!delivery_date||!message){
      toast.error("please fill the all input fields")
      return;
    }
   

    const formData={
      name,
      department,
      project_title,
      cost_expectation,
      mobile_number,
      mail_id,
      college_name,
      place,
      batch_memebers,
      delivery_date,
      message
    };
 
    try{
     
      const response =await axios.post("https://sinewavetechnologies.in/sendmail",formData)
      //response.data({msg:"data send succesfully"})
      console.log("submitted",response.data)
      if(response.status === 200){
        toast.success("Form submitted successfully")
        setName("");
        setDepartment("");
        setProject_title("");
        setCost_expectation("")
        setMobile_number("")
        setMail_id("")
        setCollege_name("")
        setPlace("")
        setBatch_members("")
        setDelivery_date("")
        setMessage("")
      }
    }
    catch(error){
      toast.error("Failed to submit form")
      console.error("error while sending data",error)
    }
  }
 
  return (
    <div className='enquiry_bg_color'>
      <div className='enquiryimg'>
        <img src={enqueryimage} alt="" />
        <div className='overlay_text'>
            <p>Enquiry</p>
        </div>
      </div>
    <div className='outer'>
      <div className='formbg'>

       <div className='head'>
        <h1>Fill your information below </h1><img src={queryicon} alt="" />
      </div>
        <div className='twoinputs'>

          <div className='form_group'>
            <label >Full name</label>
            <input type="text" placeholder='eg., johndoe' value={name} onChange={(e)=>setName(e.target.value)}/>
          </div>

          <div className='form_group'>
            <label>Your department & year</label>
            <input type="text" placeholder='Enter your department,year' value={department} onChange={(e)=>setDepartment(e.target.value)}/>
          </div>

        </div>

        <div className='twoinputs'>
          <div className='form_group'>
            <label>Your project title & Domain</label>
            <input type="text" placeholder='Enter your topic here' value={project_title} onChange={(e)=>setProject_title(e.target.value)} />
          </div>
          <div className='form_group'>
            <label >Your cost expectation</label>
            <input type="number" placeholder='eg., 5000' value={cost_expectation} onChange={(e)=>setCost_expectation(e.target.value)}/>
          </div>
        </div>

        <div className='twoinputs'>
          <div className='form_group'>
            <label>Mobile number</label>
            <input type="number" placeholder='Enter your mobile number here' value={mobile_number} onChange={(e)=>setMobile_number(e.target.value)} />
          </div>
          <div className='form_group'>
            <label >Your mail-id</label>
            <input type="email" placeholder='e.g., johndoe@example.com' value={mail_id}  onChange={(e)=>setMail_id(e.target.value)}/>
          </div>
        </div>

        <div className='twoinputs'>
          <div className='form_group'>
            <label>Which college you are</label>
            <input type="text" placeholder='Enter your college name here' value={college_name} onChange={(e)=>setCollege_name(e.target.value)} />
          </div>
          <div className='form_group'>
            <label>Where are you from</label>
            <input type="email" placeholder='Enter your place here' value={place} onChange={(e)=>setPlace(e.target.value)}/>
          </div>
        </div>
        <div className='twoinputs'>
          <div className='form_group'>
            <label>Batch members</label>
            <input type="number" placeholder='Enter how many memebers in your project' value={batch_memebers} onChange={(e)=>setBatch_members(e.target.value)}/>
          </div>
          <div className='form_group'>
            <label>Delivery date</label>
            <input type="text" placeholder='Enter your expected delivery date here' value={delivery_date} onChange={(e)=>setDelivery_date(e.target.value)} />
          </div>
        </div>

        <div className='textarea'>
          <label>Leave your messages</label>
          <textarea placeholder='Type your messages' value={message} onChange={(e)=>setMessage(e.target.value)}>
          </textarea>
        </div>

        <button onClick={handleSubmit}>
          Submit
        </button>
      <ToastContainer position='top-center' style={{borderRadius:"4px"}}/>
      </div>
    </div>
  </div>
  )
}

export default Enquiry